import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{attrs:{"id":"dashboard","fluid":"","tag":"section"}},[_c(VRow,{attrs:{"align":"center","justify":"center"}},[_c(VCol,{staticClass:"text-center header",attrs:{"cols":"12","sm":"6","lg":"3"}},[_vm._v(" Logout process.. ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }